import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'sm' | 'md' | 'lg';
  showDescription?: boolean;
}

export default function MovieCard({ movie, size = 'md', showDescription = false }: MovieCardProps) {
  const sizeClasses = {
    sm: 'w-[160px]',
    md: 'w-[200px]',
    lg: 'w-[240px]',
  };

  const imageHeight = {
    sm: 'h-[220px]',
    md: 'h-[280px]',
    lg: 'h-[340px]',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className={`${sizeClasses[size]} group block flex-shrink-0`}
      title={`${movie.title} - 天美麻花星空影视免费观看`}
    >
      <div className={`relative ${imageHeight[size]} rounded-lg overflow-hidden mb-3`}>
        <img
          src={movie.coverImage}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 天美麻花星空影视高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm text-primary-400 text-xs font-semibold px-2 py-1 rounded-md">
          {movie.rating}
        </div>
        {movie.isNew && (
          <div className="absolute top-2 left-2 bg-accent-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            新
          </div>
        )}
        {movie.isHot && !movie.isNew && (
          <div className="absolute top-2 left-2 bg-secondary-500 text-white text-xs font-semibold px-2 py-1 rounded-md">
            热
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center justify-center w-full py-2 rounded-md bg-primary-500/90 text-background-950 text-xs font-semibold">
            <i className="ri-play-circle-fill mr-1"></i>
            立即观看
          </div>
        </div>
      </div>
      <h3 className="text-white text-sm font-medium leading-tight line-clamp-1 group-hover:text-primary-400 transition-colors duration-200">
        {movie.title}
      </h3>
      {showDescription && (
        <p className="text-foreground-600 text-xs mt-1 line-clamp-2 leading-relaxed">
          {movie.description}
        </p>
      )}
      <div className="flex items-center gap-3 mt-1.5">
        <span className="text-foreground-600 text-xs">{movie.year}</span>
        <span className="text-foreground-600 text-xs">{movie.category}</span>
      </div>
    </Link>
  );
}